import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { toast } from "sonner";

import { setActiveSession } from "@/lib/auth-client";

export function useSwitchSession() {
	const router = useRouter();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (sessionToken: string) => {
			const response = await setActiveSession({ sessionToken });

			if (response?.error) {
				throw new Error(response.error.message ?? "切换账号失败");
			}
			return response.data;
		},
		onError: (error) => {
			toast.error(error.message || "切换账号失败");
		},
		onSuccess: async () => {
			queryClient.clear();
			await router.invalidate();
		},
	});
}
